module.exports = __webpack_public_path__ + "static/media/membership-bg.8bbe7943.jpg";